import { documentDirectory } from "../../utils/fileSystemCompat"
import React, { useEffect, useState } from 'react'
import { Dimensions, StyleSheet, View, Platform } from 'react-native'
import { Image } from 'expo-image'
import * as FileSystem from 'expo-file-system'

// Importaciones condicionales para reanimated (no disponible completamente en web)
let Animated: any
let useAnimatedStyle: any

if (Platform.OS !== 'web') {
    const reanimated = require('react-native-reanimated')
    Animated = reanimated.default
    useAnimatedStyle = reanimated.useAnimatedStyle
}

const { width, height } = Dimensions.get('window')

export const GamificationAnimatedBackground = ({ offset, parallaxImages }) => {
    const isWeb = Platform.OS === 'web'
    
    const animatedImageStyle = isWeb 
        ? {} 
        : useAnimatedStyle(() => {
            return {
                transform: [
                    {
                        translateY: offset.value * 0.5,
                    },
                ],
            }
        })
    
    //Agregar nombre de imagen acá para el mapeo
    //Las imagenes deben tener dimensiones seteadas para levantar correctamente del local
    //Las de la izquierda piden solo alto, las de la derecha piden alto y ancho
    
    const ContainerView = isWeb ? View : Animated.View
    const ImageComponent = isWeb ? Image : Animated.Image
    
    return (
        <ContainerView style={[{ position: 'absolute', bottom: 0, zIndex: 0, width: width }, animatedImageStyle]}>
            <ImageComponent
                style={{
                    position: 'absolute',
                    width: width,
                    top: -50,
                }}
                source={require('../../../assets/gamification/gami_finish.png')}
            />
            {parallaxImages
                .sort((a, b) => b.index - a.index)
                .map((item, index) => {
                    return <ParallaxImage key={item.name + index} item={item} />
                })}
            <ImageComponent
                style={{
                    position: 'absolute',
                    width: width,
                    bottom: 0,
                }}
                source={require('../../../assets/gamification/gami_init.png')}
            />
        </ContainerView>
    )
}

export const ParallaxImage = React.memo(({ item }: any) => {
    const isWeb = Platform.OS === 'web'
    const AnimatedImage = isWeb ? Image : Animated.createAnimatedComponent(Image)
    const [image, setImage] = useState(item.name)
    const style = StyleSheet.create({
        imageStyle: item.styles,
    })
    const searchImage = async (image: string) => {
        if (!image) {
            return { uri: '' } // fallback
        }

        const directoryUri = `${documentDirectory}unzipped/gamification/${image}`
        const fileInfo = await FileSystem.getInfoAsync(directoryUri)

        if (fileInfo.exists) {
            return { uri: fileInfo.uri }
        }

        return { uri: '' }
    }
    useEffect(() => {
        const fetchImage = async () => {
            const imageResult = await searchImage(item.name)
            setImage(imageResult)
        }

        fetchImage()
    }, [item])
    return <AnimatedImage style={[style.imageStyle]} source={image} contentFit={'contain'} /> // cachePolicy={'memory'}
})
